import Velocity from 'velocity-animate';

export default function initCharterTabs() {
	const tabsNavLinks = document.querySelectorAll('.charter-tabs-nav__item a');

	if (!tabsNavLinks.length) return;
	
	const initNavItem = document.querySelector('.charter-tabs-nav__item_active');
	const navInner = document.querySelector('.charter-tabs-nav__list');
	const navContainer = document.querySelector('.charter-tabs-nav');

	alignActiveNavItem(initNavItem, navInner, navContainer);
}

function alignActiveNavItem(item, inner, container) {
	if (window.innerWidth > 1000) return;

	const leftEdge = inner.offsetLeft;
	const rightEdge = inner.offsetLeft + inner.offsetWidth;
	const navItemLeft = item.getBoundingClientRect().left;
	const navItemRight = item.getBoundingClientRect().right;

	const outOfBoundaries = (navItemLeft < leftEdge) || (navItemRight > rightEdge) || (rightEdge > window.innerWidth);

	if (outOfBoundaries) {
		const options = {
			container,
			duration: 400,
			axis: 'x'
		}

		if (navItemLeft < leftEdge) {
			options.offset = -leftEdge;
		}

		options.offset = leftEdge;

		Velocity(item, 'scroll', options);
	}
}
